import type {TJoyButtonVariants, TJoyIconsColors} from '@maltjoy/core-vue';
import useModuleConfig from './useModuleConfig';

export function useVariants() {
    const isResourcesCenterTheme = useModuleConfig().theme === 'resources-center';

    const button: TJoyButtonVariants = isResourcesCenterTheme ? 'main' : 'primary';
    const icon: TJoyIconsColors = 'neutral';

    return {
        button,
        icon,
    };
}
